import React, {useContext} from "react";
import { RouterState, RouterStore } from "mobx-state-router";
import async from "../../components/Async";
import { ModalState } from "../../components/elements/modal/GenericModal";
import { Modal2State } from "../../components/elements/modal2/GenericModal2";
import { StatusState } from "../../components/configs/status/StatusState";
import CreateCode from "../../components/codes/create/CreateCodeDomain";
import QrPreviewState from "../../components/qr/qrpreview/QrPreviewState";
import { EditCodeState } from "../../components/codes/edit/EditCodeState";
import { CodeModelList } from "../../models/codes/Code";
import { GenericToastState } from "../../components/elements/toast/GenericToastState";
import CodeListState from "../../components/codes/list/CodeListState";
import { buildColumns } from "../../components/codes/list/CodeListView";
import IosCreate from "react-ionicons/lib/IosCreate";
import IosPaper from "react-ionicons/lib/IosPaper"
import {applySnapshot, getEnv, getSnapshot, onSnapshot, resolveIdentifier, types} from "mobx-state-tree";
import {UtmModalState} from "../../components/utms/modal/UtmModalState";
import {RuleSetModalState} from "../../components/configs/rulesets/modal/RuleSetModalState";
import {CreateRuleSetState} from "../../components/configs/rulesets/create/CreateRuleSetState";
import {TreeNode} from "../../components/configs/rulesets/create/CreateRuleForm";
import {UtmSelectState} from "../../components/elements/utms/UtmSelectState";
import {Utm} from "../../models/utms/UtmModel";
import {initUtmParameterSelectState} from "../../components/utms/utils/UtmUtils";
import {initParameterSetModal, initParameterSelectOptions} from "../../components/configs/parametersets/utils/ParameterSetsUtil";
import {TagModel} from "../../models/tags/TagModel";
import {GroupSelectState} from "../../components/elements/groups/GroupSelectState";
import DesignerState from "../../components/qr/designer/DesignerState";
import ColorState from "../../components/qr/designer/color/ColorState";
import EyesAndModulesState from "../../components/qr/designer/eyesAndModules/EyesAndModulesState";
import LogoState from "../../components/qr/designer/logo/LogoState";
import FrameAndCaptionsState from "../../components/qr/designer/frameAndCaption/FrameAndCaptionsState";
import CaptionState from "../../components/qr/designer/frameAndCaption/CaptionState";
import {v4 as uuidv4} from 'uuid';
import ImageAndCharacteristicsState
  from "../../components/qr/designer/imageAndCharacteristics/ImageAndCharacteristicsState";
import {DesignerModalState} from "../../components/qr/modal/DesignerModalState";
import {ParameterSetModalState} from "../../components/configs/parametersets/modal/ParameterSetModalState";
import ParameterStore from "../../stores/domain/ParameterStore";
import CodeParamsStore from "../../stores/domain/parameters/CodeParamsStore";
import ScanParamsStore from "../../stores/domain/parameters/ScanParamsStore";
import {CodeParamsTypeSelectState} from "../../components/elements/parameters/codeType/CodeParamsTypeSelectState";
import {ScanParamsTypeSelectState} from "../../components/elements/parameters/scanType/ScanParamsTypeSelectState";
import CountParamsStore from "../../stores/domain/parameters/CountParamsStore";
import PremiumParamsStore from "../../stores/domain/parameters/PremiumParamsStore";
import CustomParamsStore from "../../stores/domain/parameters/CustomParamsStore";
import {CountParamsTypeSelectState} from "../../components/elements/parameters/countType/CountParamsTypeSelectState";
import {
  PremiumParamsTypeSelectState
} from "../../components/elements/parameters/premiumType/PremiumParamsTypeSelectState";
import {CustomParamsTypeSelectState} from "../../components/elements/parameters/customType/CustomParamsTypeSelectState";
import Parameters from "../../models/Parameters";
import {BehaviorModalState} from "../../components/elements/behaviorModal/BehaviorModalState";
import {QrDownloadState} from "../../components/qr/qrpreview/qrDownload/QrDownloadState";
import {codeBehavior, filterSessionConstants, protocolConstants} from "../../utils/constants";
import {MediaFile} from "../../models/mediaFiles/MediaFileModel";
import {MediaFileSelectState} from "../../components/elements/mediaFiles/MediaFileSelectState";
import {ExtendedDataSettingModalState} from "../../components/extendedData/modal/ExtendedDataSettingModalState";
import {checkUserPermissions} from "../../utils/requiredRolesCheck";
import {DefaultSettingModel} from "../../models/defaultSetting/DefaultSettingModel";
import {SimulateCodeState} from "../../components/codes/simulate/codeSimulateState";
import {SimulatePreviewState} from "../../components/codes/simulate/codeSimulatePreviewState";
import { initRuleSetModalState } from "src/components/configs/rulesets/utils/RuleSetsUtil";
import { initDesignerTemplateModal, isMediaFileEnabled } from "src/components/qr/designer/utils/DesignerTemplateUtil";
import {registerInitialFilterSnapshot} from "../../utils/filterStorage";


// Page Async Reference, for lazy loading in UI
const CreateCodePage = async(() => import("../../pages/codes/create/Create"));
const CodesPage = async(() => import("../../pages/codes"));
const EditCodePage = async(() => import("../../pages/codes/edit/Edit"));
const DeleteCodePage = async(() => import("../../components/codes/delete/DeleteView"));
const SimulateCodePage = async(() => import("../../pages/codes/simulate"));


export const viewMap = {
  createCode: <CreateCodePage/>,
  deleteCode: <DeleteCodePage/>,
  editCode: <EditCodePage/>,
  codes: <CodesPage/>,
  simulateCode : <SimulateCodePage/>
}

export const routeDefinitions = [
  {
    path: "createCode", //"/codes/new",
    name: "Create",
    header: "Codes",
    icon: IosCreate,
    component: CreateCodePage,
    children: null
  },
  {
    path: "codes",
    name: "Manage",
    icon: IosPaper,
    component: CodesPage,
    children: null
  }
];


export const routeTransitions = [
  {
    name: 'createCode',
    pattern: '/codes/new',
    beforeEnter: checkUserPermissions,
    onEnter: async ( // Create Code Route
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const BaseConfig = {
        "dataShape": 0, "imageFormat": "png",
        "colorMode": "rgb", "quietZone": 4,
        "errorCorrection": "M", "size": 1,
        "resolution": 1200,
      }
      let {queryParams} = toState;
      const {rootStore} = routerStore.options;
      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const codeTypeSelectState = rootStore.rootUiStore.codeTypeSelectStore;
      const secondaryCodeTypeSelectStore = rootStore.rootUiStore.secondaryCodeTypeSelectStore;
      secondaryCodeTypeSelectStore?.setSecondary(true);
      const publishDomainSelectStore = rootStore.rootUiStore.publishDomainSelectStore;
      const pageTemplateSelectStore = rootStore.rootUiStore.pageTemplateSelectStore
      const tenantStore = rootStore.domainStore.tenantStore;
      groupSelectState?.selectDefaultGroup(tenantStore.defaultGroupUuid);
      const mediaFileSelectState = rootStore.rootUiStore.mediaFileSelectState
      const dimensionsMultiSelectStore = rootStore.rootUiStore.dimensionsMultiSelectState
      const shortUriPattern =  rootStore.appConfigs?.configs?.short_uri_regex;

      const staticBehaviorEnabled = rootStore.appConfigs.configs.static_behavior_enabled;
      const protocolDefaultsEnabled = rootStore.appConfigs?.configs?.protocol_defaults_enabled ?? false;
      const protocolDefaults = rootStore.appConfigs?.configs?.protocol_defaults ?? {};

      // Initialize dimensionsMultiSelectStore for designer modal
      dimensionsMultiSelectStore.init();
      dimensionsMultiSelectStore.setDefaults();

      if(queryParams.codeType){
        const codeType = codeTypeSelectState.store.codeTypes.find((codeType) => codeType.name === queryParams.codeType)
        if (codeType) {
          codeTypeSelectState.select(codeType);
        }
      }

      const dimensionUuids = dimensionSelectViewState?.dimensionSelectStates // filter dimensions on group
        .filter(selectState => selectState?.dimension?.type === "CONDITIONAL")
        .map(selectState => selectState?.selectStateUuid);
      dimensionUuids.forEach(uuid => {
        dimensionSelectViewState?.dimensionSelectStates?.find(selectState => selectState?.selectStateUuid === uuid).getListOnGroup(groupSelectState?.selectedGroup?.uuid)
      })

      //groupSelectState.clearSelected();
      // tagSelectStore?.tagStore?.init(); //reset tags
      // tagSelectStore?.setSelectedTags([]); //need to reset tags when on new page due to reuse domain store
      // const utmSelectState = rootStore.rootUiStore.utmSelectState;
      // const parameterSetSelectState = rootStore.rootUiStore.parameterSetSelectState;
      // await parameterSetSelectState.store.getParameterSets();

      // const codeParamsStore = CodeParamsStore.create({
      //   storeUuid: "codeParamsStore"
      // })
      // const scanParamsStore = ScanParamsStore.create({
      //   storeUuid: "scanParamsStore"
      // })
      // const countParamsStore = CountParamsStore.create({
      //   storeUuid: "countParamsStore"
      // })
      // const premiumParamsStore = PremiumParamsStore.create({
      //   storeUuid: "premiumParamsStore"
      // })
      // const customParamsStore = CustomParamsStore.create({
      //   storeUuid: "customParamsStore"
      // })
      // const gs1ParamsStore = GS1ParamsStore.create({
      //   storeUuid: "gs1"
      // })
      // await rootStore.rootUiStore.attachPageState('codeParamsStore', codeParamsStore)
      // await rootStore.rootUiStore.attachPageState('scanParamsStore', scanParamsStore)
      // await rootStore.rootUiStore.attachPageState('countParamsStore', countParamsStore)
      // await rootStore.rootUiStore.attachPageState('premiumParamsStore', premiumParamsStore)
      // await rootStore.rootUiStore.attachPageState('customParamsStore', customParamsStore)
      // await rootStore.rootUiStore.attachPageState('gs1ParamsStore', gs1ParamsStore)


      dimensionSelectViewState?.clearSelections()
      dimensionSelectViewState?.setDefaults()
      const modalStateCreateCode = ModalState.create({});
      const statusViewState = StatusState.create(({title:"Status"}))
      // const ruleSetSelectState = rootStore.rootUiStore.ruleSetSelectState;
      // const ruleTypeSelectState = rootStore.rootUiStore.ruleTypeSelectState;
      // ruleSetSelectState?.store?.clearSearchParams() // to reset ruleSets store same problem above for tags
      // ruleSetSelectState?.store?.init({}) // reset ruleSets
      // const rootNode = TreeNode.create({
      //   nodeUuid: '4',
      //   parent: null,
      //   order: 0,
      //   children: [],
      //   showIndent: false,
      //   showUnindent: false,
      //   position: '0',
      //   volatileRuleTypeStore: ruleTypeSelectState.store
      // })
      //   const createRuleSetState = CreateRuleSetState.create({
      //     isModalUi:true,
      //     ruleTypeSelectState:ruleTypeSelectState,
      //     rootNode: rootNode
      //   })
      // const ruleSetModalState = RuleSetModalState.create({
      //   ruleSetSelectState:ruleSetSelectState,
      //   createRuleSetState:createRuleSetState

      // })

      // init parameter select options
      await initParameterSelectOptions(rootStore)

      const ruleSetModalState = await initRuleSetModalState(rootStore, "createRuleSet", false)

      // const utmParameterSelectStore = rootStore.rootUiStore.utmParameterSelectState;
      // utmParameterSelectStore.setCodeParamsTypeSelectState(rootStore.rootUiStore.codeParamsStore);
      // utmParameterSelectStore.setGS1ParamsTypeSelectState(rootStore.rootUiStore.gs1ParamsStore);
      // utmParameterSelectStore.setUtmExtedDataSelectState(rootStore.rootUiStore.extendedDataSelectStore);

      const utmParameterSelectStore = await initUtmParameterSelectState(rootStore);
      const utmSelectState = rootStore.rootUiStore.utmSelectState;
      utmSelectState?.setSelectedUtm()
      const utmModalState = UtmModalState.create({
        utmSelectState:utmSelectState,
        utmParameterSelectState: utmParameterSelectStore,
        groupSelectStore:groupSelectState,
        utm:Utm.create({uuid:"modalUtm"})
      })
      utmModalState?.initializeSelectVisibility();
      const extendedDataStore = rootStore.domainStore.extendedDataStore;
      await extendedDataStore.init();

      const extendedDataSetSelectStore = rootStore.rootUiStore.extendedDataSetSelectStore;
      extendedDataSetSelectStore.store.init();

      const extendedDataSelectStore = rootStore.rootUiStore.extendedDataSelectStore;
      extendedDataSelectStore.store.init();

      const extendedDataSettingModalState = ExtendedDataSettingModalState.create({
        extendedDataSetSelectStore: extendedDataSetSelectStore,
        extendedDataSelectStore: extendedDataSelectStore
      });

      rootStore.rootUiStore.parameterSetSelectState?.setSelectedParameterSet()
      const parameterSetModalState = await initParameterSetModal(rootStore, groupSelectState, false)

      rootStore.rootUiStore.utmSelectState?.store.init({})
      const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
      const groupSelectStore = rootStore.rootUiStore.groupSelectStore

      const mediaFileEnabled = isMediaFileEnabled(rootStore.appConfigs)
      const designerModalState = initDesignerTemplateModal(getSnapshot(rootStore.domainStore.dashboardStore), qrConfigSelectStore, groupSelectStore, false, dimensionsMultiSelectStore, tagSelectStore, rootStore.rootUiStore.mediaFileSelectState, mediaFileEnabled)

      const qrPreviewStore = QrPreviewState.create({
        isEditCodePage: false,
        qrConfigSelectStore: qrConfigSelectStore,
        baseQRImageFormData: JSON.stringify(BaseConfig),
        modalStore: ModalState.create({}),
        qrDownloadStore: QrDownloadState.create({}),
        // dashboardStore: getSnapshot(rootStore.domainStore.dashboardStore),
        defaultImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.defaultImageConfig,
        v1ImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.v1ImageConfig,
        showDownloadButton: false
      })
      await rootStore.rootUiStore.attachPageState('qrPreviewStore', qrPreviewStore)
      // Clear stale previewCodeAndEditDesignState from any prior code-list preview so
      // downloadConfig cannot resolve a codeUuid for an unsaved code.
      rootStore.rootUiStore.detachPageState('previewCodeAndEditDesignState')
      let createCodeViewState;
      const snapShot = (queryParams.q)?rootStore.rootUiStore?.globalCache[`clone:${queryParams.q}`]:null
      const snapShotImageUuid = snapShot?.images?.configs[0].uuid
      if (snapShot){ //hydrate form with snapShot for cloning a code
        groupSelectState?.selectGroup(snapShot?.owner?.groupUuid);
        // Refresh domain store AFTER group selection to get cloner's domains, not default domains
       await publishDomainSelectStore.refresh(groupSelectState?.selectedGroup);

        // Select the specific domain from the snapshot
        if (snapShot?.shortUrl?.domain) {
          const targetDomain = snapShot.shortUrl.domain;
          const domainStore = publishDomainSelectStore.publishDomainStore;

          // Find the domain object that matches the snapshot's domain string
          const originalDomain = domainStore.publishDomains.find(
            domain => domain.domain === targetDomain
          );

          if (originalDomain) {
            // Explicitly select the original domain and wait for prefixes to load
            await publishDomainSelectStore.selectPublishDomain(originalDomain);

            // Also restore the prefix if it exists - now prefixes should be loaded
            if (snapShot?.shortUrl?.prefix) {
              const targetPrefix = snapShot.shortUrl.prefix;
              const matchingPrefix = originalDomain.prefixes?.find(
                prefix => prefix.prefix === targetPrefix
              );
              if (matchingPrefix) {
                originalDomain.selectPrefix(matchingPrefix);
              } else {
                console.warn('No matching prefix found for:', targetPrefix);
              }
            }
          }
        }

        // dimensionSelectViewState?.setDimensions(snapShot?.owner?.dimensions)
        codeTypeSelectState?.select(snapShot?.type);
        statusViewState?.setStatus(snapShot?.status);
        statusViewState?.setCloneForm(true);
        tagSelectStore?.setSelectedTags(snapShot?.tags?.flatMap((tag => tag.uuid.split('.')[1])));
        createCodeViewState = CreateCode.create({
          name: "",
          groupSelectStore: groupSelectState,
          dimensionSelectViewState: dimensionSelectViewState,
          tagSelectStore: tagSelectStore,
          codeTypeSelectStore: codeTypeSelectState,
          secondaryCodeTypeSelectStore:secondaryCodeTypeSelectStore,
          publishDomainSelectStore: publishDomainSelectStore,
          pageTemplateSelectStore: pageTemplateSelectStore,
          mediaFileSelectState: mediaFileSelectState,
          isExperienceDynamic: false,
          utmModalState: utmModalState,
          modalStore: modalStateCreateCode,
          statusViewState: statusViewState,
          ruleSetModalState: ruleSetModalState,
          designerModalState: designerModalState,
          parameterSetModalState: parameterSetModalState,
          extendedDataSettingModalState: extendedDataSettingModalState,
          behaviorModalState: BehaviorModalState.create({}),
          behavior: snapShot.behavior,
          rules: JSON.stringify(snapShot.rules),
          utm:Utm.create({uuid:"appliedUtm", ...snapShot?.utm}),
          parameters: Parameters.create({
            codeParamType: snapShot?.parameters?.codeParamType,
            scanParamType: snapShot?.parameters?.scanParamType,
            countParamType: snapShot?.parameters?.countParamType,
            premiumParamType: snapShot?.parameters?.premiumParamType,
            customParamType: snapShot?.parameters?.customParamType,
            gs1ParamType: snapShot?.parameters?.gs1ParamType,
            edParamType: snapShot?.parameters?.edParamType
          }),
          mediaFile: MediaFile.create({uuid:"mediaFileSnapshot", ...snapShot?.images?.configs[0]}),
          shortUriPattern: shortUriPattern,
          isStaticBehaviorEnabled: staticBehaviorEnabled,
          protocolDefaultsEnabled: protocolDefaultsEnabled,
          protocolDefaults: protocolDefaults
        });
        createCodeViewState.setStatus(snapShot?.status);
        if (snapShotImageUuid) { // clone image
          const configStore = rootStore.rootUiStore.qrConfigSelectStore.configStore
          //fetch image qrConfig
          const imageQrConfig = await configStore.fetchImageConfigWithId(snapShotImageUuid)
          const data ={
            "qrPreview": imageQrConfig.image,
            "qrImageFormData": imageQrConfig.qrConfig,
            "owner": {"groupUuid":imageQrConfig.owner.groupUuid}
          }
          const clonedImageConfig = await getEnv(rootStore).imageConfigManager.applyToCode(data)
          const {uuid} = clonedImageConfig.data
          createCodeViewState?.handleImageUuidChange(uuid)
          const fetchedClone = await configStore.fetchImageConfigWithId(uuid)
          qrPreviewStore?.setQRImageFormData(fetchedClone?.qrConfig)
          qrConfigSelectStore.setSelectedConfig(fetchedClone)
        }
        // tagSelectStore?.tagStore?.init()
        createCodeViewState?.updateExperienceData(snapShot?.data)

        // Restore secondary experience data for GS1 and other complex codes
        if (snapShot?.dataDetail?.secondaryExperience?.data) {
          createCodeViewState?.updateSecondaryExperienceData(snapShot.dataDetail.secondaryExperience.data);
        }
      } else { // create new code
        // Refresh domain store with selected group for new code creation
        await publishDomainSelectStore.refresh(groupSelectState?.selectedGroup);
        tagSelectStore?.tagStore?.init(); //reset tags
        tagSelectStore?.setSelectedTags([]); //need to reset tags when on new page due to reuse domain store
        const defaultSettingFeatureFlag = rootStore?.appConfigs?.features?.cmp_ui_default_settings?.enabled
        createCodeViewState = CreateCode.create({
          groupSelectStore: groupSelectState,
          dimensionSelectViewState: dimensionSelectViewState,
          tagSelectStore: tagSelectStore,
          codeTypeSelectStore: codeTypeSelectState,
          secondaryCodeTypeSelectStore:secondaryCodeTypeSelectStore,
          publishDomainSelectStore: publishDomainSelectStore,
          pageTemplateSelectStore: pageTemplateSelectStore,
          mediaFileSelectState: mediaFileSelectState,
          isExperienceDynamic: true, // <-- appconfig per tenant/account/user
          utmModalState: utmModalState,
          parameterSetModalState: parameterSetModalState,
          extendedDataSettingModalState: extendedDataSettingModalState,
          behaviorModalState: BehaviorModalState.create({}),
          behavior: codeBehavior.DYNAMIC,
          modalStore: modalStateCreateCode,
          statusViewState: statusViewState,
          ruleSetModalState: ruleSetModalState,
          designerModalState: designerModalState,
          utm:Utm.create({uuid:"appliedUtm"}),
          parameters: Parameters.create({}),
          defaultSetting: DefaultSettingModel.create({uuid:"Create Default Setting"}),
          mediaFile: MediaFile.create({uuid:"mediaFileCreate",singleUseFile:true}),
          defaultSettingFeatureFlag: defaultSettingFeatureFlag,
          shortUriPattern: shortUriPattern,
          isStaticBehaviorEnabled: staticBehaviorEnabled,
          protocolDefaultsEnabled: protocolDefaultsEnabled,
          protocolDefaults: protocolDefaults
        });

        const userRoles = rootStore?.userRoles;
        createCodeViewState.setDefaultStatusBasedOnRoles(userRoles);
        codeTypeSelectState.setFsm(null);
        tagSelectStore?.tagStore?.setFilterOn(groupSelectState?.selectedGroup?.uuid);
        if(queryParams.platform) {
          createCodeViewState?.updateExperienceData({platform: queryParams?.platform});
        }
      }
      await mediaFileSelectState.store.getMediaFiles({"usage":"content","status":"UPLOADED"})
      //const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
      const defaultConfig =
        qrConfigSelectStore.configStore?.defaultConfiguration?.find(element => element.is_default === true)

      defaultConfig && qrConfigSelectStore.selectConfig(defaultConfig)
      !defaultConfig && !snapShotImageUuid && qrConfigSelectStore.setSelectedConfig("")
      createCodeViewState?.selectExperience(codeTypeSelectState?.selected,snapShot?snapShot.behavior:null)
      createCodeViewState?.selectSecondaryExperience(secondaryCodeTypeSelectStore?.selected,snapShot?snapShot.behavior:null)

      qrPreviewStore?.setQrProtocol(createCodeViewState?.selectedProtocol || protocolConstants.HTTP);
      qrPreviewStore?.setIsStatic(createCodeViewState?.behavior === codeBehavior.STATIC);

      await rootStore.rootUiStore.attachPageState('createCodeViewState', createCodeViewState)
      await createCodeViewState.parameterSetModalState.fetchAllParameters()
      if (snapShot) {
        console.log("createCode: length of snapShot: ", JSON.stringify(snapShot).length);
        createCodeViewState?.extendedDataSettingModalState?.setConsumer(createCodeViewState.selectExtendedDataSelection);
        extendedDataSettingModalState?.hydrateModal(snapShot);

        // Hydrate media file manager with cloned code's media files
        try {
          const mediaFileManager = rootStore.rootUiStore.mediaFileSelectStateManager;
          const apiMediaFileManager = getEnv(rootStore).mediaFileManager;

          if (mediaFileManager && apiMediaFileManager && snapShot.mediaFiles) {
            // Initialize the manager with the experience's uiSchema first
            if (createCodeViewState?.experienceSelected?.uiSchema) {
              const uiSchema = JSON.parse(createCodeViewState.experienceSelected.uiSchema);
              mediaFileManager.initializeFromUISchema(uiSchema, createCodeViewState.setMediaFileToSchema);
            }

            // Then hydrate with clone data
            const hydrationResult = await mediaFileManager.hydrateFromCodeData(snapShot, apiMediaFileManager);

            // Create a generic MediaFile for widget compatibility using the hydration result
            if (hydrationResult.hydratedCount > 0) {
              const genericMediaFile = hydrationResult.createGenericMediaFile();
              if (genericMediaFile) {
                createCodeViewState.mediaFile = genericMediaFile;
              }
            }
          }
        } catch (error) {
          console.error('Failed to hydrate media file states during cloning:', error);
        }
      } else {
          await createCodeViewState?.fetchAndHydrateDefaultSetting();
      }
      createCodeViewState.setOnSelectChanges()

      createCodeViewState.dimensionSelectViewState?.setDefaults()
      // Final dimension restoration after setDefaults() (which clears dimensions)
      if (snapShot?.owner?.dimensions) {
        dimensionSelectViewState?.setDimensions(snapShot.owner.dimensions);
      }

      !snapShotImageUuid && qrConfigSelectStore.configStore.removeImageConfig()
      rootStore.rootUiStore.editCodeState &&  rootStore.rootUiStore.editCodeState.setUuid("") // <-- hack to remove carry over group selection from edit to create
    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      console.log("exit", fromState)
      console.log("exit", toState)
      console.log("exit", routerStore)
      const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
      qrConfigSelectStore.configStore.removeImageConfig()
      const createCodeViewState = rootStore.rootUiStore.createCodeViewState
      createCodeViewState?.handleImageUuidChange(undefined)
      createCodeViewState?.setCancelUploads(true);
      // rootStore.rootUiStore.detachPageState('qrPreviewStore');
      // rootStore.rootUiStore.attachPageState('createCodeViewState');
    }
  },
  {
    name: 'deleteCode',
    pattern: '/codes/delete/:id',
    beforeEnter: checkUserPermissions,
    onEnter: async ( // Delete Code Route
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {params} = toState
      const {rootStore} = routerStore.options;
    }
  },
  {
    name: 'editCode',
    pattern: '/codes/edit/:id',
    beforeEnter: checkUserPermissions,
    onEnter: async ( // Edit Code Route
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {params, queryParams: {isEditable: isEditableStr}} = toState
      const isEditable = isEditableStr !== 'false';
      const isView = isEditable !== undefined ? !isEditable : false
      const {rootStore} = routerStore.options;
      const BaseConfig = {
        "dataShape": 0, "imageFormat": "png",
        "colorMode": "rgb", "quietZone": 4,
        "errorCorrection": "M", "size": 1,
        "resolution": 1200,
      }

      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const codeTypeSelectState = rootStore.rootUiStore.codeTypeSelectStore;
      const secondaryCodeTypeSelectStore = rootStore.rootUiStore.secondaryCodeTypeSelectStore;
      secondaryCodeTypeSelectStore?.setSecondary(true);
      const pageTemplateSelectStore = rootStore.rootUiStore.pageTemplateSelectStore;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const auditActionEnabled = rootStore.appConfigs?.configs?.audit_action_enabled;
      const mediaFileSelectState = rootStore.rootUiStore.mediaFileSelectState;
      const dimensionsMultiSelectStore = rootStore.rootUiStore.dimensionsMultiSelectState

      // Initialize dimensionsMultiSelectStore for designer modal
      dimensionsMultiSelectStore.init();
      dimensionsMultiSelectStore.setDefaults();

      const codeParamsStore = CodeParamsStore.create({
        storeUuid: "codeParamsStore"
      })
      const scanParamsStore = ScanParamsStore.create({
        storeUuid: "scanParamsStore"
      })
      const countParamsStore = CountParamsStore.create({
        storeUuid: "countParamsStore"
      })
      const premiumParamsStore = PremiumParamsStore.create({
        storeUuid: "premiumParamsStore"
      })
      const customParamsStore = CustomParamsStore.create({
        storeUuid: "customParamsStore"
      })
      await rootStore.rootUiStore.attachPageState('codeParamsStore', codeParamsStore)
      await rootStore.rootUiStore.attachPageState('scanParamsStore', scanParamsStore)
      await rootStore.rootUiStore.attachPageState('countParamsStore', countParamsStore)
      await rootStore.rootUiStore.attachPageState('premiumParamsStore', premiumParamsStore)
      await rootStore.rootUiStore.attachPageState('customParamsStore', customParamsStore)

      const qrConfigStore = rootStore.domainStore.qrConfigStore
      const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
      const modalStateEditCode = ModalState.create({});
      const statusViewState = StatusState.create(({title: "Status", isEditForm: true, isView: isView}))
      // const utmParameterSelectStore = rootStore.rootUiStore.utmParameterSelectState;
      // utmParameterSelectStore.setCodeParamsTypeSelectState(rootStore.rootUiStore.codeParamsStore);
      // utmParameterSelectStore.setGS1ParamsTypeSelectState(rootStore.rootUiStore.gs1ParamsStore);
      // utmParameterSelectStore.setUtmExtedDataSelectState(rootStore.rootUiStore.extendedDataSelectStore);

      // init parameter select options
      await initParameterSelectOptions(rootStore)

      const utmParameterSelectStore = await initUtmParameterSelectState(rootStore);

      rootStore.rootUiStore.utmSelectState?.setSelectedUtm()
      const utmModalState = UtmModalState.create({
        utmSelectState:rootStore.rootUiStore.utmSelectState,
        utmParameterSelectState: utmParameterSelectStore,
        utm:Utm.create({uuid:"appliedUtm"}),
        isView: isView
      })

      rootStore.rootUiStore.parameterSetSelectState?.setSelectedParameterSet()
      const parameterSetModalState = await initParameterSetModal(rootStore, groupSelectState, isView)

      const ruleSetModalState = await initRuleSetModalState(rootStore, "editRuleSet", isView)

      const mediaFileEnabled = isMediaFileEnabled(rootStore.appConfigs);
      const designerModalState = initDesignerTemplateModal(getSnapshot(rootStore.domainStore.dashboardStore), qrConfigSelectStore, groupSelectState, isView, dimensionsMultiSelectStore, tagSelectStore, rootStore.rootUiStore.mediaFileSelectState, mediaFileEnabled)

      const extendedDataStore = rootStore.domainStore.extendedDataStore;
      await extendedDataStore.init();

      const extendedDataSetSelectStore = rootStore.rootUiStore.extendedDataSetSelectStore;
      extendedDataSetSelectStore.store.init();

      const extendedDataSelectStore = rootStore.rootUiStore.extendedDataSelectStore;
      extendedDataSelectStore.store.init();

      const extendedDataSettingModalState = ExtendedDataSettingModalState.create({
        extendedDataSetSelectStore: extendedDataSetSelectStore,
        extendedDataSelectStore: extendedDataSelectStore,
        isView: isView
      });

      const editCodeState = EditCodeState.create({
        groupSelectStore: groupSelectState,
        tagSelectStore: tagSelectStore,
        pageTemplateSelectStore: pageTemplateSelectStore,
        dimensionSelectViewState: dimensionSelectViewState,
        codeTypeSelectStore: codeTypeSelectState,
        secondaryCodeTypeSelectStore:secondaryCodeTypeSelectStore,
        isExperienceDynamic: true,
        extendedDataSettingModalState: extendedDataSettingModalState,
        uuid: params.id,
        modalStore: modalStateEditCode,
        statusViewState: statusViewState,
        utmModalState: utmModalState,
        ruleSetModalState: ruleSetModalState,
        designerModalState: designerModalState,
        existedDesignerState: getSnapshot(designerModalState.designerViewStore),
        parameterSetModalState: parameterSetModalState,
        parameters: Parameters.create({}),
        mediaFileSelectState: mediaFileSelectState,
        mediaFile: MediaFile.create({uuid:"mediaFileEdit",singleUseFile:true}),
        mediaFiles: {},
        isView: isView,
        isAuditActionEnabled: auditActionEnabled
      });
      const modalState = ModalState.create({});
      // const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
      const qrDownloadStore = QrDownloadState.create({});
      const qrPreviewStore = QrPreviewState.create({
        modalStore: modalState,
        qrConfigStore: qrConfigStore,
        qrConfigSelectStore: qrConfigSelectStore,
        baseQRImageFormData: JSON.stringify(BaseConfig),
        isEditCodePage: true,
        qrDownloadStore: qrDownloadStore,
        // dashboardStore: getSnapshot(rootStore.domainStore.dashboardStore),
        defaultImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.defaultImageConfig,
        v1ImageConfig: getSnapshot(rootStore.domainStore.dashboardStore).apps?.v1ImageConfig
      })
      await mediaFileSelectState.store.getMediaFiles({"usage":"content","status":"UPLOADED"}) //only allow uploaded files
      await rootStore.rootUiStore.attachPageState('qrPreviewStore', qrPreviewStore)
      await rootStore.rootUiStore.attachPageState('editCodeState', editCodeState)
      await editCodeState.parameterSetModalState.fetchAllParameters()
      await editCodeState?.setShortUrlListener(qrPreviewStore.setShortUrl)
      editCodeState?.setNameListener(qrPreviewStore.updateName);
      editCodeState?.setOnSelectChanges()
      const res = await editCodeState?.fetchWithID()

      qrPreviewStore?.setIsStatic(editCodeState?.behavior === codeBehavior.STATIC);
      // Re-apply shortUrl for static codes: fetchWithID fires urlListener before isStatic is set,
      // so replaceProtocol may have lowercased the protocol (e.g. HTTP:// → http://).
      if (editCodeState?.behavior === codeBehavior.STATIC && res?.shortUrl?.uri) {
        qrPreviewStore?.setShortUrl(res?.shortUrl?.uri);
      }
      // Protocol is now initialized in EditCodeState.hydrateForm()
      qrPreviewStore?.setOriginalProtocol(editCodeState?.selectedProtocol || protocolConstants.HTTP);

      const imageUuid = res?.images?.configs[0]?.uuid
      editCodeState?.codeTypeSelectStore?.setEditMode(true);

      if (imageUuid) {
        editCodeState?.handleImageUuidChange(imageUuid)
        const imageResponse = await rootStore.domainStore.qrConfigStore?.fetchImageConfigWithId(imageUuid)
        qrPreviewStore?.setQRImageFormData(imageResponse?.qrConfig)
        console.log("imageResponse", imageResponse)
        editCodeState.designerModalState.designerViewStore.hydrateEditComponent(imageResponse)
        // qrConfigSelectStore?.setHydrateModal(editCodeState?.designerModalState.designerViewStore?.hydrateEditComponent)
        qrConfigSelectStore.setSelectedConfig(imageResponse);
        // qrPreviewStore.selectQRConfig(imageResponse)
      }else{
        qrConfigSelectStore.setSelectedConfig("")
        qrPreviewStore.updateImage(qrPreviewStore.shortUrl)
      }
    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      console.log("exit", fromState)
      console.log("exit", toState)
      console.log("exit", routerStore)
      const qrConfigSelectStore = rootStore.rootUiStore.qrConfigSelectStore
      const editCodeState = rootStore.rootUiStore.editCodeState
      rootStore.rootUiStore.mediaFileSelectState?.store?.removeSingleUseFilesFromList({"usage":"content"})
      await rootStore.rootUiStore.detachPageState('DesignerState')
      await rootStore.rootUiStore.detachPageState('DesignerModalState')
      editCodeState?.updateExperienceData("{}")
      editCodeState?.handleImageUuidChange("")
      editCodeState?.setCancelUploads(true);
      rootStore.rootUiStore.mediaFileSelectState.select(null)
      qrConfigSelectStore.configStore.removeImageConfig()
      editCodeState?.codeTypeSelectStore.setEditMode(false)
      qrConfigSelectStore?.setHydrateModal(null)
    }
  },
  {
    name: 'codes',
    pattern: '/codes',
    onEnter: async ( // Code List Route
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;

      const viewStateExisting = rootStore.rootUiStore.codeListViewState;

      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const codeFilterSelectState = rootStore.rootUiStore.codeFilterSelectState;
      const codeOwnerFilterSelectState = rootStore.rootUiStore.codeOwnerFilterSelectState;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const tagFilterSelectState = rootStore.rootUiStore.tagFilterSelectState;
      const groupFilterSelectState = rootStore.rootUiStore.groupFilterSelectState;
      const pageTemplateSelectStore = rootStore.rootUiStore.pageTemplateSelectStore;
      const qrtemplateSelectState = rootStore.rootUiStore.qrtemplateSelectStore;
      const mediaFileSelectState = rootStore.rootUiStore.mediaFileSelectState
      await mediaFileSelectState.store.getMediaFiles() //get all media files for code list view


      const featureEnabled = rootStore.appConfigs?.features?.cmp_search_index?.enabled;
      const auditActionEnabled = rootStore.appConfigs?.configs?.audit_action_enabled;
      groupSelectState.selectGroup(undefined);
      tagSelectStore?.tagStore?.init(); //reset tags
      tagSelectStore?.setSelectedTags([]); //need to reset tags when on new page due to reuse domain store
      codeFilterSelectState.reset();
      codeOwnerFilterSelectState.reset();
      dimensionSelectViewState.reset();
      tagFilterSelectState.reset();
      groupFilterSelectState.reset();

      const codes = CodeModelList.create({});
      const toastState = GenericToastState.create({})
      const modalState = ModalState.create({});
      const modal2State = Modal2State.create({});
      const viewState = CodeListState.create({
        store: codes,
        modalStore: modalState,
        modal2Store: modal2State,
        toastStore: toastState,
        tagSelectStore: tagSelectStore,
        groupSelectStore: groupSelectState,
        pageTemplateSelectStore: pageTemplateSelectStore,
        codeFilterSelectState: codeFilterSelectState,
        codeOwnerFilterSelectState: codeOwnerFilterSelectState,
        dimensionSelectViewState: dimensionSelectViewState,
        qrtemplateSelectStore:qrtemplateSelectState,
        tagFilterSelectState: tagFilterSelectState,
        groupFilterSelectState: groupFilterSelectState,
        isElasticSearchEnabled: featureEnabled,
        isAuditActionEnabled: auditActionEnabled,
        mediaFileSelectState: mediaFileSelectState
      });

      registerInitialFilterSnapshot(viewState, filterSessionConstants.CODE_SESSION_STORAGE_KEY, "codeFilterSelectState");

      viewState.setColumns(buildColumns(routerStore, viewState))
      console.log("Attaching Page State : codeListViewState ")
      await rootStore.rootUiStore.attachPageState('codeListViewState', viewState)
      viewState.loadFiltersFromSessionStorage()
      await viewState.fetchFilters();
      viewState.loadColumnsFromSession()
      viewState.setColumns(buildColumns(routerStore, viewState));
      featureEnabled ? await viewState.search() : viewState.refresh();
    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      await rootStore.rootUiStore.codeListViewState.store.removeList()
      console.log("Detaching Page State : codeListViewState ")
      //rootStore.rootUiStore.detachPageState('codeListViewState')
    }
  },
  {
    name: 'simulateCode',
    pattern: '/codes/simulate/:id',
    beforeEnter: checkUserPermissions,
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {params} = toState
      const {rootStore} = routerStore.options;


      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const codeTypeSelectState = rootStore.rootUiStore.codeTypeSelectStore;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const ruleTypeStore = rootStore?.domainStore?.ruleTypeStore
      const simulatePreviewState = SimulatePreviewState.create({})


      const simulateCodeState = SimulateCodeState.create({
        groupSelectStore: groupSelectState,
        tagSelectStore: tagSelectStore,
        dimensionSelectViewState: dimensionSelectViewState,
        codeTypeSelectStore: codeTypeSelectState,
        isExperienceDynamic: true,
        uuid: params.id,
        ruleTypeStore: ruleTypeStore
      });



      await rootStore.rootUiStore.attachPageState('simulatePreviewState', simulatePreviewState)
      await rootStore.rootUiStore.attachPageState('simulateCodeState', simulateCodeState)

      await simulateCodeState?.fetchWithID()
      simulateCodeState.initSchema()

    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      console.log("exit", fromState)
      console.log("exit", toState)
      console.log("exit", routerStore)
    }
  },
]

